// extracted by mini-css-extract-plugin
export default {"collapse":"IssueDetail_collapse__PHfIS","descriptionBox":"IssueDetail_descriptionBox__YqSJH","caretIcon":"IssueDetail_caretIcon__zQ4M-"};